export class Client{
    id;
    salesforceId;
    salesforceNumber;
    name;
    product;
    constructor(client?){
        Object.assign(this, client);
    }
}